import { render } from "./TotalOrders.vue?vue&type=template&id=422fa441&scoped=true"
import script from "./TotalOrders.vue?vue&type=script&lang=js"
export * from "./TotalOrders.vue?vue&type=script&lang=js"

import "./TotalOrders.vue?vue&type=style&index=0&id=422fa441&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422fa441"]])

export default __exports__